module.exports = __webpack_public_path__ + "img/viktoria.b857050.webp";